import gql from "graphql-tag";

export default gql`
mutation archiveRemoveScreen ($profile: ScreenProfile!, $resourceId: ID!) {
  archiveRemoveScreen (profile: $profile, resourceId: $resourceId) {
        id,
        success,
        message
    }
}`